import { FC, useCallback, useMemo } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Asset, Box, Card, IconButton, Typography, useAsset } from '@altermaind/web/ui';
import { useDialog } from '@/_shared/hooks/useDialog';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';
import { CardItem } from '../../../state';

type Props = {
  metricsMap: CardItem[];
};

export const CardContact: FC<Props> = ({ metricsMap }) => {
  const t = useTranslations('aiPlayground.admin.landingPlayground.aiPlayground.noResult');
  const tShared = useTranslations('aiPlayground.admin.landingPlayground');
  const { genericResponsiveValue } = useResponsiveStyle();
  const { openDialog: openContacts } = useDialog('contacts');

  const backGroundImage = useAsset('images', 'bgPlaygroundCard');

  const getFirstMetricWithPeople = useMemo(() => {
    return metricsMap
      .sort((a, b) => (b?.peopleWithInitialLevel ?? 0) - (a?.peopleWithInitialLevel ?? 0))
      .slice(0, 1);
  }, [metricsMap]);

  const goToContact = useCallback(() => {
    openContacts({});
  }, [openContacts]);

  return (
    <Box mt='xxl'>
      <Card
        backgroundImage={`url(${backGroundImage})`}
        backgroundSize={genericResponsiveValue({
          breakPoints: { desktop: 'cover' },
          defaultValue: 'cover',
        })}
        backgroundPosition={genericResponsiveValue({
          breakPoints: { desktop: 'center' },
          defaultValue: 'top',
        })}
        display='flex'
        flexDirection={genericResponsiveValue({
          breakPoints: { desktop: 'row' },
          defaultValue: 'column',
        })}
        backgroundColor='primary/interactive'
        alignItems='center'
        textAlign='center'
      >
        <Box flex='1' alignItems='center'>
          <Asset domain='images' name='logoAltermaind' width='m' />
          <Typography mt='xxs' variant='h3'>
            {t('title')}
          </Typography>
          <Typography mt='s' variant='h2'>
            {getFirstMetricWithPeople[0]?.peopleWithInitialLevel &&
            getFirstMetricWithPeople[0]?.peopleWithInitialLevel > 0
              ? t('subTitleSkill', { name: getFirstMetricWithPeople[0]?.title })
              : t('subTitle')}
          </Typography>
          <Typography mt='xs' variant='p2/light'>
            {getFirstMetricWithPeople[0]?.peopleWithInitialLevel &&
            getFirstMetricWithPeople[0]?.peopleWithInitialLevel > 0
              ? t('descriptionSkill', {
                  name: getFirstMetricWithPeople[0]?.title,
                  count: getFirstMetricWithPeople[0]?.peopleWithInitialLevel,
                  personLabel:
                    getFirstMetricWithPeople[0]?.peopleWithInitialLevel === 1
                      ? tShared('person')
                      : tShared('people'),
                })
              : t('description')}
          </Typography>
          <IconButton
            color='primary/interactive'
            variant='positive'
            mt='s'
            prefixSvg='send'
            svgStyle={{ fill: 'primary', size: 'xs' }}
            textStyle={{ ml: 'xxxs' }}
            onClick={goToContact}
            style={{ margin: '0 auto' }}
          >
            {t('buttonLabel')}
          </IconButton>
        </Box>
      </Card>
    </Box>
  );
};
